import { Fragment, memo } from 'react';

import { CommentRow, InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';

import { getDurationText } from '../../../../utils/activities';
import ActivityDetailContainer from '../ActivityDetailContainer';

const CheckInDetail = memo(({ activity, getIsCommentCollapsed, labels, shared }) => {
    const { companyContent, finalContactContent, opportunityRow, rightContent, titleRow } = shared;

    const durationInSeconds = parseInt(activity.CheckinMinutes, 10)
        ? parseInt(activity.CheckinMinutes, 10) * 60
        : 0;
    const durationText = getDurationText(durationInSeconds);

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                main: (
                    <Fragment>
                        <InfoRowSection>
                            <InfoRow label={labels.duration} value={durationText} />
                        </InfoRowSection>
                        <CommentRow
                            text={activity.Description}
                            getIsCommentCollapsed={getIsCommentCollapsed}
                        />
                    </Fragment>
                ),
                right: (
                    <Fragment>
                        {titleRow}
                        <InfoRowSection>
                            <InfoRow
                                label={labels.account}
                                value={companyContent}
                                rightContent={rightContent}
                            />
                            <InfoRow label={labels.contact} value={finalContactContent} />
                            <InfoRow label={labels.role} value={activity.ContactRole} />
                            {opportunityRow}
                        </InfoRowSection>
                    </Fragment>
                ),
            }}
        />
    );
});

CheckInDetail.displayName = 'CheckInDetail';

export default CheckInDetail;
